import React, { useEffect } from "react";
import abImg from "../../images/112.jpg";
import abImg2 from "../../images/about_4.jpg";
import abImg4 from "../../images/10.jpg";
 
const About = (props) => { 
  useEffect(() => {
    if (window.location.hash === "#indian-pharmacies") {
      const el = document.getElementById("indian-pharmacies");
      if (el) {
        el.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, []);

  return (
    <section className="about-section separator-padding">
      <div className="container">
        <div className="row">
          <div className="col-lg-6 why-chemist">
            <div className="about-img-wrap">
              <div className="about-img-top">
                <img src={abImg} alt="" />
              </div>
            </div>
          </div>
          <div className="col-lg-6 why-chemist-div-second">
            <div className="about-text">
              <h2>Why Chemist For All?</h2>
              <p>
              We launched Chemist For All to solve a critical problem: rising healthcare costs and limited access to treatment. As an affordable online pharmacy, our mission is to make reliable, budget-friendly medicines available without compromising on safety or effectiveness.
              </p>
              <p>
              With each order, we uphold strict standards and personalized service. Our support team is always available at support@chemistforall.com to answer your questions and assist with any concerns related to your healthcare needs.
              </p>
            </div> 
          </div>
        </div>
        <div className="row">
          <div className="col-lg-6">
            <div className="about-text">
              <h2>Manufacturers</h2>
              <p>
              At Chemist For All, all products come directly from certified Indian pharmaceutical manufacturers. These companies are globally recognized for maintaining high safety, compliance, and quality control measures. Every medicine listed on our online pharmacy is carefully vetted to ensure it’s safe for our customers.
              </p>
              <p>
              Many of the medicines may carry different brand names in other countries, but they share the same active ingredients and clinical benefits. Our focus is to bring you trusted, affordable alternatives through a streamlined chemist home delivery model.
              </p>
              <p>
              Some of our pharmaceutical partners include:
              Ranbaxy Laboratories Ltd. | Cipla Ltd. | Dr. Reddy's Laboratories Ltd. | Nicholas Piramal India Ltd. | Aurobindo Pharma Ltd. | Glaxosmithkline Pharmaceuticals Ltd. | Lupin Ltd. | Cadila Healthcare Ltd. | Sun Pharmaceutical Industries. Ltd. | Wockhardt Ltd. | Aventis Pharma Ltd. | Orchid Chemicals & Pharmaceuticals Ltd. | Ipca Laboratories Ltd. | Alembic Ltd. | Pfizer Ltd. | Morepen Laboratories Ltd. | U.S.V. Ltd. | Matrix Laboratories Ltd. | Biocon Ltd. | Novartis India Ltd. | Torrent Pharmaceuticals Ltd. | Abbott India Ltd. 
              </p>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="about-img-wrap">
              <div className="about-img-top">
                <img src={abImg2} alt="" />
              </div>
            </div>
          </div>
        </div>

        <div className="row" id="indian-pharmacies">
        <div className="col-lg-6">
            <div className="about-img-wrap">
              <div className="about-img-top">
                <img src={abImg4} alt="" />
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="about-text">
              <h2>Indian Pharmacies</h2>
              <p>
              India is a global leader in the production of affordable, high-quality generic drugs. With advanced infrastructure and cost-efficient operations, Indian pharmaceutical companies are partnering with international platforms to meet global healthcare demands. The success of the online pharmacy model is one reason Indian pharmacies are gaining popularity.
              </p>
              <p>
              As demand for generic and over-the-counter medications continues to grow, Indian companies are expanding into digital platforms to ensure greater reach and affordability. Online access, paired with chemist home delivery, has created a new era of accessible healthcare for all.

              </p>
              <p>
              Chemist For All is proud to be part of this evolution. As an online pharmacy, we are committed to delivering effective and affordable treatment options to customers in the USA, UK, Australia, and beyond.
              </p>
              <p style={{ fontStyle: 'italic' }}><a href="https://www.chemistforall.com/" style={{ fontStyle: 'italic' }}>To know more about Indian Pharmacies, visit us at www.chemistforall.com</a></p>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default About;